
import { BUSINESS_UNIT_METADATA } from './business-unit.metadata';
import { BusinessUnit } from './business-unit.model';
import { GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class BusinessUnitEntityDecoratorBase extends GenericEntityDecorator<BusinessUnit, string> {
  constructor() {
    super(BUSINESS_UNIT_METADATA, {
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): string {
    if (params == null || params.buId == null) {
      return null;
    }
    return params.buId;
  }
  toKeyUrlPathSegments(key: string): string {
    if (key == null) {
      return null;
    }
    return key;
  }
  toKeyRouteSegments(item: BusinessUnit): any[] {
    const key: string = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




